import { AsyncPipe, NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { groupBy } from 'lodash';

import { Subject } from 'rxjs';
import { DPFormField } from 'src/app/core/models/DPFormField';
import { DPFormFieldType } from 'src/app/core/models/enums/DPFormFieldType';
import { DynamicFieldComponent } from '../dynamic-field/dynamic-field.component';
import { SubfieldVisiblePipe } from '../../pipes/subfield-visible.pipe';
import { FormControlPipe } from '../../pipes/form-control.pipe';
import { ItemClassPipe } from '../../pipes/item-class.pipe';

/**
 * Dynamic form component.
 *
 * Renders form based on dynamic fields.
 */
@Component({
  selector: 'app-dynamic-form',
  standalone: true,
  imports: [
    NgClass,
    AsyncPipe,
    ReactiveFormsModule,
    DynamicFieldComponent,
    SubfieldVisiblePipe,
    FormControlPipe,
    ItemClassPipe,
  ],
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
})
export class DynamicFormComponent implements OnChanges {
  // Dyanmic form fields
  @Input() fields: DPFormField[] = [];

  // Form disabled state
  @Input() disabled: boolean;

  // Angular Form Group object
  @Input() form: UntypedFormGroup;

  @Input() customColumnTpls: Record<string, TemplateRef<any>>;

  // This subject is to send markAsTouched event from parent form to individual field component.
  // Used in multivalue form.
  @Input() markAsTouched: Subject<void>;

  // OnUpdate event emitted if the field is multivalue
  @Output() onUpdate = new EventEmitter();

  fieldsByParent: Record<string, DPFormField[]> = {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fields && changes.fields.currentValue) {
      changes.fields.currentValue.forEach((f) => {
        if (f.type === DPFormFieldType.Multivalue) {
          this.form.controls[f.name].markAsTouched();
        }
      });
      this.fieldsByParent = groupBy(changes.fields.currentValue, 'parentField');
    }
  }
}
